import {
    MARKING_ACTION_CLICK,
    MARKING_EVENT_TRACK_ACTION,
    MARKING_EVENT_TRACK_FORM_SUBMIT,
    MARKING_EVENT_TRACK_VIRTUAL,
    MARKING_INTERECTIONS,
    MARKING_VEHICLE_INSURANCE,
} from "../consts/markingsConst";
import helpers from "../utils/helpers";

// listener action !!
export const markingTrackAction = () => {
    const group = MARKING_VEHICLE_INSURANCE;
    const category = MARKING_INTERECTIONS;
    const eventAction = MARKING_ACTION_CLICK;
    const label = "No encuentro modelo";
    const event = MARKING_EVENT_TRACK_ACTION;

    helpers.getTagAction(group, category, eventAction, label, event);
};

export const markingTrackSeeCoverage = () => {
    const group = "";
    const category = MARKING_INTERECTIONS;
    const eventAction = MARKING_ACTION_CLICK;
    const label = "Ver coberturas";
    const event = MARKING_EVENT_TRACK_ACTION;

    helpers.getTagAction(group, category, eventAction, label, event);
};

export const markingTrackValidateData = (label) => {
    const group = MARKING_VEHICLE_INSURANCE;
    const category = MARKING_INTERECTIONS;
    const eventAction = MARKING_ACTION_CLICK;

    const event = MARKING_EVENT_TRACK_ACTION;

    helpers.getTagAction(group, category, eventAction, label, event);
};

// cuando se envian los formularios !!
export const markingSendForm = (formName) => {
    const channel = MARKING_VEHICLE_INSURANCE;
    const event = MARKING_EVENT_TRACK_FORM_SUBMIT;

    helpers.getTagChannel(channel, formName, event);
};

export const markingChannel = (name, event) => {
    const channel = MARKING_VEHICLE_INSURANCE;

    helpers.getTagChannel(channel, name, event);
};

export const markingInitialVehicleData = () => {
    const name = "";

    helpers.getTagVirtual(name, MARKING_EVENT_TRACK_VIRTUAL);
};

export const markingTrackDontHasModel = () => {
    const group = MARKING_VEHICLE_INSURANCE;
    const category = MARKING_INTERECTIONS;
    const eventAction = MARKING_ACTION_CLICK;
    const label = "No encuentro modelo";
    const event = MARKING_EVENT_TRACK_ACTION;

    helpers.getTagAction(group, category, eventAction, label, event);
};

export const markingAudienceId = (audience_id) => {
    return helpers.setTagDigitalID(audience_id);
};

